(function () {
    'use strict';

    angular
        .module('franchiser.directives')
        .directive('personCompanyAssociationHistory', PersonCompanyAssociationHistory)

    /** @ngInject */
    function PersonCompanyAssociationHistory($rootScope, PersonService, UtilHelper, PATHS_FRANCHISER) {
        function PersonCompanyAssociationHistoryController($scope) {
            const vm = this;

            vm.tableCallServer = (tableState, stCtrl) => {
                if (!vm.stCtrl && stCtrl)
                    vm.stCtrl = stCtrl;

                if (!tableState && vm.stCtrl) {
                    vm.stCtrl.pipe();
                    return;
                }

                if (!vm.isVisible)
                    return;

                vm.isLoading = true;

                const pagination = tableState.pagination;
                const start = pagination.start || 0;
                const number = pagination.number || 10;

                getAssociationHistory(start, number, tableState);
            }

            let removeWatchIsVisible = $scope.$watch('vm.isVisible', newValue => {
                if (newValue && !vm.personAssociationHistory.length)
                    vm.tableCallServer();
            })

            $scope.$on('$destroy', () => {
                removeWatchIsVisible();
            })

            init();

            function getAssociationHistory(skip, perPage, tableState) {
                let parameters = prepareParameters(skip, perPage, tableState);

                PersonService
                    .getAssociationHistory(parameters)
                    .then(success => {
                        vm.personAssociationHistory = success.Registers;
                        tableState.pagination.numberOfPages = success.NumberOfPages;

                        vm.isLoading = false;
                    }, error => {
                        vm.personAssociationHistory = [];
                        vm.isLoading = false;
                        UtilHelper.errorCallback(error);
                    });
            }

            function prepareParameters(skip, perPage, tableState) {
                let params = {
                    Skip: skip,
                    PerPage: perPage,
                    PersonId: vm.personId,
                    OrderBy: 'RegistrationDate',
                    OrderDescending: true
                }

                if (tableState.sort.predicate) {
                    params.OrderBy = tableState.sort.predicate;
                    params.OrderDescending = tableState.sort.reverse;
                }

                return params;
            }

            function init() {
                vm.canUserEdit = $rootScope.canUserEdit;
                vm.isLoading = true;
                vm.personAssociationHistory = [];
            }
        }

        return {
            bindToController: true,
            controller: PersonCompanyAssociationHistoryController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/directives/person-company-association-history/person-company-association-history.html`,
            scope: {
                personId: '=',
                isVisible: '='
            }
        }
    }
}());